


































import { Component, Mixins } from "vue-property-decorator";
import { ForegroundDrawableObjectMixin } from "./mixins";
import { Rectangle, Size } from "../../../../domain/drawing";
import { GraphItem } from "../../../../domain/document/items";
import { CoordinateCalculator, LineInformation } from "./graph";

@Component({
})
export default class GraphObject extends Mixins(ForegroundDrawableObjectMixin) {
  editingSource: GraphItem;

  get drawerRectangle(): Rectangle {
    return new Rectangle(
      this.rectangle.topLeft.addValue(4, 4),
      new Size(Math.max(this.rectangle.width - 8, 1), Math.max(this.rectangle.height - 8, 1)));
  }

  get drawerStyleProperties() {
    return {
      position: "absolute",
      top: this.drawerRectangle.x + "px",
      left: this.drawerRectangle.y + "px",
      width: this.drawerRectangle.width + "px",
      height: this.drawerRectangle.height + "px",
    };
  }

  get shouldDrawBorder(): boolean {
    return !!this.editingSource.shouldDrawBorder;
  }

  get lines(): LineInformation[] {
    const calculator = new CoordinateCalculator(this.drawerRectangle.size, this.editingSource.scaleKind);
    return calculator.calculate(this.editingSource.graphSubItems);
  }

  get horizontalDivideLines(): LineInformation[] {
    const calculator = new CoordinateCalculator(this.drawerRectangle.size, this.editingSource.scaleKind);
    return calculator.getHorizontalDivideLines(this.editingSource.horizontalDivideCount);
  }
}
